module.exports = __webpack_public_path__ + "img/company_name.72ccb743.svg";